/** App-directory (grid menu) data access. */

import { api } from './api';
import type { AppDirectoryDisplay, AppDirectoryEntry } from '@/types';

export async function fetchAppDirectory(): Promise<AppDirectoryEntry[]> {
  const { data } = await api.get<AppDirectoryEntry[]>('/api/v1/apps/directory');
  // Bedrock returns these alphabetical by name with Bedrock itself injected at position 0 when
  // its switcher policy allows. Order is preserved verbatim — it is the platform's decision,
  // not ours.
  return data;
}

export async function fetchAppDirectoryDisplay(): Promise<AppDirectoryDisplay> {
  const { data } = await api.get<AppDirectoryDisplay>('/api/v1/apps/directory/display');
  return data;
}
